import axiosClient from "../axiosClient";
import {
  GETALL_COMMONTYPE_URL,
  GETALL_NATUREOFBUSINESS_URL,
  CREATE_NATUREOFBUSINESS_URL,
  UPDATE_NATUREOFBUSINESS_URL,
  DELETE_NATUREOFBUSINESS_URL,
  GETALLCOMMONMASTER_URL,
  CREATE_COMMONMASTER_URL,
  CREATE_COMMONTYPE_URL,
  DELETE_COMMONTYPE_URL,
  UPDATE_COMMONTYPE_URL,
  DELETE_COMMONMASTER_URL,
  UPDATE_COMMONMASTER_URL,
  GETDETAIL_PRODUCTMASTER_URL,
  DELETE_PRODUCTMASTER_URL,
  UPDATE_PRODUCTMASTER_URL,
  CREATE_PRODUCTMASTER_URL,
  GETALL_PRODUCTMASTER_URL,
  GETALLCURRENCY_URL,
  GETALL_BRANCHMASTER_URL,
  CREATE_BRANCHMASTER_URL,
  UPDATE_BRANCHMASTER_URL,
  DELETE_BRANCHMASTER_URL,
  GETDETAIL_BRANCHMASTER_URL,
  GETALL_EMPLOYEEMASTER_URL,
  CREATE_EMPLOYEEMASTER_URL,
  UPDATE_EMPLOYEEMASTER_URL,
  DELETE_EMPLOYEEMASTER_URL,
  GETALL_CUSTOMER_URL,
  CREATE_CUSTOMER_URL,
  UPDATE_CUSTOMER_URL,
  DELETE_CUSTOMER_URL,
  GETBYID_CUSTOMER_URL,
  CREATE_INDIVIDUALID_URL,
  GETALL_COUNTRY_URL,
  GETALL_VENDOR_URL,
  GETALL_INDIVIDUALID_URL,
  DELETE_INDIVIDUALID_URL,
  UPDATE_INDIVIDUALID_URL,
  GETALL_CORPORATE_URL,
  CREATE_CORPORATE_URL,
  UPDATE_CORPORATE_URL,
  DELETE_CORPORATE_URL,
  GETBYID_CORPORATE_URL,
  CREATE_CORPORATE_UPLOAD_URL,
  DELETE_CORPORATE_UPLOAD_URL,
  UPDATE_CORPORATE_UPLOAD_URL,
  GET_CORPORATE_UPLOAD_URL,
  GETALL_RATEMARGIN_URL,
  CREATE_RATEMARGIN_URL,
  UPDATE_RATEMARGIN_URL,
  DELETE_RATEMARGIN_URL,
  GETRATE_RATEMARGIN_URL,
  GETBYTENENT_BRANCHMASTER_URL,
  CREATE_VENDOR_URL,
  UPDATE_VENDOR_URL,
  GETBYID_VENDOR_URL,
  GETALL_SALEPURCHASE_URL,
  GETALL_SALEPURCHASEBYDATE_URL,
  GETALL_SALEPURCHASELATEST_URL,
  DOWNLOAD_INDIVIDUALID_URL,
  DELETE_VENDOR_URL,
  CREATE_VENDOR_UPLOAD_URL,
  DELETE_VENDOR_UPLOAD_URL,
  UPDATE_VENDOR_UPLOAD_URL,
  GET_VENDOR_UPLOAD_URL,
  GETALL_STATE_MASTER,
  CREATE_STATE_MASTER,
  GETALL_BANKDETAILMASTER_URL,
  DELETE_BANKDETAILMASTER_URL,
  GETBY_BANKDETAILMASTER_URL,
  UPDATE_BANKDETAILMASTER_URL,
  CREATE_BANKDETAILMASTER_URL,
  GETALL_BANKMASTER_URL,
  DELETE_BANKMASTER_URL,
  GETBY_BANKMASTER_URL,
  UPDATE_BANKMASTER_URL,
  CREATE_BANKMASTER_URL,
  GET_RATE_VTM_URL,
  GETBY_IDTYPE_URL,
  CREATE_RATE_VTM_URL,
} from "../endpoints";

//common master
export const commonmasterService = {
  getallCommonMaster: async () => {
    try {
      const response = await axiosClient.get(GETALLCOMMONMASTER_URL);
      return response.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  createCommonMaster: async (payload: any) => {
    try {
      const response = await axiosClient.post(CREATE_COMMONMASTER_URL, payload);
      return response.data;
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  updateCommonMaster: async (payload: any) => {
    try {
      const response = await axiosClient.put(UPDATE_COMMONMASTER_URL, payload);
      return response.data;
    } catch (error) {
      throw new Error("Update failed");
    }
  },

  deleteCommonMaster: async (id: string) => {
    console.log(id);

    try {
      const response = await axiosClient.delete(DELETE_COMMONMASTER_URL, {
        params: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
};
//risk
export const nobservice = {
  getallNob: async () => {
    try {
      const response = await axiosClient.get(GETALL_NATUREOFBUSINESS_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Get Failed!");
    }
  },

  createNob: async (payload: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_NATUREOFBUSINESS_URL,
        payload
      );
      return response.data;
    } catch (error) {
      throw new Error("Creation Failed!");
    }
  },

  updateNob: async (payload: any) => {
    try {
      console.log("updateData", payload);

      const response = await axiosClient.put(
        UPDATE_NATUREOFBUSINESS_URL,
        payload
      );
      return response.data;
    } catch (error) {
      throw new Error("Updation Failed!");
    }
  },
  deleteNob: async (id: string) => {
    console.log(id);

    try {
      const response = await axiosClient.delete(DELETE_NATUREOFBUSINESS_URL, {
        params: { id },
      });
      return response.data;
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
};
//common type master
export const CommonTypeService = {
  getCommonType: async () => {
    try {
      const response = await axiosClient.get(GETALL_COMMONTYPE_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_COMMONTYPE_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (updateData: any) => {
    try {
      const response = await axiosClient.put(UPDATE_COMMONTYPE_URL, updateData);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    console.log(id);

    try {
      const response = await axiosClient.delete(DELETE_COMMONTYPE_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
};
//currency master
export const CurrencyMasterService = {
  getCurrencyMaster: async () => {
    try {
      const response = await axiosClient.get(GETALLCURRENCY_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
//country master
export const CountryMasterService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_COUNTRY_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
// product master
export const ProductMasterService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_PRODUCTMASTER_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PRODUCTMASTER_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (updateData: any) => {
    try {
      const response = await axiosClient.put(
        UPDATE_PRODUCTMASTER_URL,
        updateData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_PRODUCTMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETDETAIL_PRODUCTMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
//branch master
export const BranchMasterService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_BRANCHMASTER_URL);

      return response.data.data.branches; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_BRANCHMASTER_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any, id: string) => {
    console.log(payload, id);

    try {
      const params = new URLSearchParams({
        id: id ?? "",
      })?.toString();
      const response = await axiosClient.put(
        `${UPDATE_BRANCHMASTER_URL}?${params}`,
        payload
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    console.log(id);

    try {
      const response = await axiosClient.delete(DELETE_BRANCHMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETDETAIL_BRANCHMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getbyTenant: async (TenantId: string) => {
    try {
      const response = await axiosClient.get(GETBYTENENT_BRANCHMASTER_URL, {
        params: { TenantId }, // Use 'data' for the request payload
      });
      return response.data.data.branches; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
//employee master
export const EmployeeMasterService = {
  getallEmployeeMaster: async () => {
    try {
      const response = await axiosClient.get(GETALL_EMPLOYEEMASTER_URL);
      return response.data.data;
    } catch (error) {
      throw new Error("Fetch Failed");
    }
  },
  createEmployeeMaster: async (payload: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_EMPLOYEEMASTER_URL,
        payload
      );
      return response.data;
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  updateEmployeeMaster: async (payload: any) => {
    try {
      console.log("payload", payload);

      const response = await axiosClient.put(
        UPDATE_EMPLOYEEMASTER_URL,
        payload
      );
      console.log("response from API:", response);
      return response.data;
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  deleteEmployeeMaster: async (id: string) => {
    console.log(id);

    try {
      const response = await axiosClient.delete(DELETE_EMPLOYEEMASTER_URL, {
        data: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
};
//individual profile
export const IndividualProfileService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_CUSTOMER_URL);

      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_CUSTOMER_URL, createData);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_CUSTOMER_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_CUSTOMER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_CUSTOMER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
// individual id
export const IndividualProfileIdService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_INDIVIDUALID_URL);

      return response.data; // Returns response data
    } catch (error) {
      return error;
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_INDIVIDUALID_URL,
        createData
      );
      return response.data;
    } catch (error: any) {
      const errorData = error?.response?.data;
      if (errorData?.success === false && Array.isArray(errorData.errors)) {
        return errorData;
      }

      return {
        success: false,
        errors: [{ description: error.message || "Something went wrong" }],
      };
    }
  },

  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_INDIVIDUALID_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      return error;
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_INDIVIDUALID_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_CUSTOMER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getbyIdType: async (IdNumber: string) => {
    try {
      const response = await axiosClient.get(GETBY_IDTYPE_URL, {
        params: { IdNumber }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  download: async (id: string) => {
    try {
      const response = await axiosClient.get(
        `${DOWNLOAD_INDIVIDUALID_URL}/${id}`,
        {
          responseType: "blob", // Required for file downloads
        }
      );
      return { data: response.data, headers: response.headers }; // Ensure both data & headers are returned
    } catch (error) {
      console.error("Download failed:", error);
      throw new Error("Loading failed");
    }
  },
};
export const VendorService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_VENDOR_URL);

      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_VENDOR_URL, createData);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_VENDOR_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_VENDOR_URL, {
        data: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_VENDOR_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  //UPLOADS
  createUpload: async (formData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_VENDOR_UPLOAD_URL,
        formData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  deleteUpload: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_VENDOR_UPLOAD_URL, {
        data: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  updateUpload: async (formData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_VENDOR_UPLOAD_URL,
        formData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Updation failed");
    }
  },
  getUpload: async (VendorFileId: string) => {
    try {
      const response = await axiosClient.get(
        GET_VENDOR_UPLOAD_URL + "/" + VendorFileId,
        {
          responseType: "blob", // Required for file downloads
        }
      );

      return { data: response.data, headers: response.headers }; // Ensure both data & headers are returned
    } catch (error) {
      console.error("Download failed:", error);
      throw new Error("Loading failed");
    }
  },
};
export const RateMasterService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_RATEMARGIN_URL);

      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_RATEMARGIN_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_RATEMARGIN_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_RATEMARGIN_URL, {
        data: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  getrate: async (CurrencyId: string) => {
    try {
      const response = await axiosClient.get(GETRATE_RATEMARGIN_URL, {
        params: { CurrencyId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getsalepurchase: async () => {
    try {
      const response = await axiosClient.get(GETALL_SALEPURCHASE_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getsalepurchasebydate: async (date: Date) => {
    try {
      const response = await axiosClient.get(GETALL_SALEPURCHASEBYDATE_URL, {
        params: { date },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getsalepurchaselatest: async () => {
    try {
      const response = await axiosClient.get(GETALL_SALEPURCHASELATEST_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getVTMLatest: async () => {
    try {
      const response = await axiosClient.get(GET_RATE_VTM_URL);
      return response.data;
    } catch (error) {
      throw new Error("VTM Latest Fetch Failed");
    }
  },
  getVTMByDate: async (date: Date) => {
    try {
      const response = await axiosClient.get(GET_RATE_VTM_URL, {
        params: { date },
      });
      return response.data;
    } catch (error) {
      throw new Error("VTM By Date Fetch Failed");
    }
  },
  createVTM: async (createVTM: any) => {
    try {
      const response = await axiosClient.post(CREATE_RATE_VTM_URL, createVTM);
      return response.data;
    } catch (error) {
      throw new Error("VTM Create Failed");
    }
  },
  updateVTM: async (updateVTM: any) => {
    try {
      const response = await axiosClient.post(CREATE_RATE_VTM_URL, updateVTM);
      return response.data;
    } catch (error) {
      throw new Error("VTM Update Failed");
    }
  },
};
export const CorporateProfileService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_CORPORATE_URL);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },

  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_CORPORATE_URL, createData);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  update: async (payload: any) => {
    try {
      const response = await axiosClient.post(UPDATE_CORPORATE_URL, payload);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_CORPORATE_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data;
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },

  getbyId: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_CORPORATE_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  //corporate profile uploads
  createUpload: async (formData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_CORPORATE_UPLOAD_URL,
        formData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  deleteUpload: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_CORPORATE_UPLOAD_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Deletion failed");
    }
  },
  updateUpload: async (formData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_CORPORATE_UPLOAD_URL,
        formData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Updation failed");
    }
  },
  getUpload: async (CorporateFileId: string) => {
    try {
      const response = await axiosClient.get(
        GET_CORPORATE_UPLOAD_URL + "/" + CorporateFileId,
        {
          responseType: "blob", // Required for file downloads
        }
      );

      return { data: response.data, headers: response.headers }; // Ensure both data & headers are returned
    } catch (error) {
      console.error("Download failed:", error);
      throw new Error("Loading failed");
    }
  },
};
export const StateMasterService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_STATE_MASTER);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },

  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_STATE_MASTER, createData);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
};
//bank master
export const BankMasterService = {
  bankCreate: async (requestData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_BANKMASTER_URL,
        requestData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Bank creation failed");
    }
  },

  bankupdate: async (payload: any, id: string) => {
    try {
      const params = new URLSearchParams({
        id: id ?? "",
      })?.toString();
      const response = await axiosClient.put(
        `${UPDATE_BANKMASTER_URL}?${params}`,
        payload
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Failed to update bank:", error);
      throw new Error("Failed to update bank");
    }
  },

  bankById: async (id: string) => {
    try {
      console.log(`Calling API with ID: ${id}`); // ✅ Debug log

      const response = await axiosClient.get(GETBY_BANKMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      console.log("API Response:", response.data); // ✅ Debug log

      return response.data;
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      throw new Error("Failed to fetch bank details");
    }
  },

  bankDeleteByID: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_BANKMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      }); // Corrected

      console.log("API Response:", response.data); // ✅ Debug log

      return response.data;
    } catch (error) {
      console.error("Failed to Delete Bank:", error);
      throw new Error("Failed to Delete Bank");
    }
  },
  bankAll: async () => {
    try {
      const response = await axiosClient.get(GETALL_BANKMASTER_URL);
      console.log("API Response:", response.data); // Debugging output
      return { data: response.data }; // Wrap response in an object if needed
    } catch (error) {
      throw new Error("Failed to fetch Bank");
    }
  },
};
//bank detail master
export const BankDetailMasterService = {
  bankCreate: async (requestData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_BANKDETAILMASTER_URL,
        requestData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Bank creation failed");
    }
  },

  bankupdate: async (payload: any, id: string) => {
    try {
      const params = new URLSearchParams({
        id: id ?? "",
      })?.toString();
      const response = await axiosClient.put(
        `${UPDATE_BANKDETAILMASTER_URL}?${params}`,
        payload
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Failed to update bank:", error);
      throw new Error("Failed to update bank");
    }
  },

  bankById: async (id: string) => {
    try {
      console.log(`Calling API with ID: ${id}`); // ✅ Debug log

      const response = await axiosClient.get(GETBY_BANKDETAILMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      console.log("API Response:", response.data); // ✅ Debug log

      return response.data;
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      throw new Error("Failed to fetch bank details");
    }
  },

  bankDeleteByID: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_BANKDETAILMASTER_URL, {
        params: { id }, // Use 'data' for the request payload
      }); // Corrected

      console.log("API Response:", response.data); // ✅ Debug log

      return response.data;
    } catch (error) {
      console.error("Failed to Delete Bank:", error);
      throw new Error("Failed to Delete Bank");
    }
  },
  bankAll: async () => {
    try {
      const response = await axiosClient.get(GETALL_BANKDETAILMASTER_URL);
      console.log("API Response:", response.data); // Debugging output
      return { data: response.data }; // Wrap response in an object if needed
    } catch (error) {
      throw new Error("Failed to fetch Bank");
    }
  },
};
